import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewPassword = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	x: "0px",
	y: "0px",
	viewBox: "0 0 75 75",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M54,25.5h-3v-6c0-8.3-6.7-15-15-15s-15,6.7-15,15v6h-3c-3.3,0-6,2.7-6,6v30c0,3.3,2.7,6,6,6h36c3.3,0,6-2.7,6-6v-30  C60,28.2,57.3,25.5,54,25.5z M26.7,19.5c0-5.1,4.2-9.3,9.3-9.3s9.3,4.2,9.3,9.3v6H26.7V19.5z M19.3,46.2h4.5  c0-6.7,5.4-12.1,12.1-12.1c2.4,0,4.6,0.7,6.4,1.9l-2.2,2.2c-1.3-0.7-2.7-1.1-4.2-1.1c-5,0-9.1,4.1-9.1,9.1h4.5l-6.1,6.1L19.3,46.2z   M48.1,46.2c0,6.7-5.4,12.1-12.1,12.1c-2.4,0-4.6-0.7-6.4-1.9l2.2-2.2c1.3,0.7,2.7,1.1,4.2,1.1c5,0,9.1-4.1,9.1-9.1h-4.5l6.1-6.1  l6.1,6.1H48.1z",
		fill: "#2771bb"
	})]
});
const ForwardRef = forwardRef(SvgNewPassword);
export default ForwardRef;
